import { Card, Col, Form, Input, Row } from "antd";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import MgmtService from "../../../../app/service/mgmtService";
import { Button } from "../../../../components";
import MgmtLayout from "../../../../components/layouts/MgmtLayout";
import { messageError, messageSuccess } from "../../../../components/toastr";

export const MgmtClientForm = () => {
    let history = useHistory();
    const mgmtService = new MgmtService();
    const [loading, setLoading] = useState(false);

    const submitClient = (data) => {
        setLoading(true);

        mgmtService.createClient(data).then(res => {
            if (res && res.status === 200) {
                messageSuccess('Cliente criado com sucesso.');
            } else {
                messageError('Erro ao cadastrar cliente.');
            }

            setLoading(false);
        }).catch(err => {

            setLoading(false);
        });
    }

    return (
        <MgmtLayout>
            <Card title='Cadastro de Cliente'>
                <Form onFinish={(data) => submitClient(data)} layout="vertical">
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Nome</b>} name="name">
                                <Input placeholder='Nome' name='name' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>API Username</b>} name="api_username">
                                <Input placeholder='API Username' name='api_username' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>API Password</b>} name="api_password">
                                <Input placeholder='API Password' name='api_password' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>KEY Suntech</b>} name="key_suntech">
                                <Input placeholder='KEY Suntech' name='key_suntech' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Token Telegram</b>} name="telegram_token">
                                <Input placeholder='Token Telegram' name='telegram_token' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>

                        <Col style={{ display: 'flex', justifyContent: 'end' }} span={24}>
                            <Button onClick={() => history.goBack()} style={{ marginRight: '10px' }}>Voltar</Button>
                            <Button htmlType='submit' loading={loading} className='successButton'>Salvar</Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </MgmtLayout>
    );
}